export default __webpack_public_path__ + "static/media/order-details.c9070e8e.pdf";